import React, {useState} from 'react';
import PopupModal from "./PopupModal";
import {Trans, useTranslation, withTranslation} from "react-i18next";
import IframeWidget from "../../utils/IframeWidget";
import {RootState} from "../../../reducers";
import {getSession, selectLocale} from "../../services/Session/reducer";
import {connect} from "react-redux";
import {useSessionService} from "../../services/Session/sessionService";
import {DateHelper} from "../../services/Common/Date/DateHelper";
import {ReactComponent as AlertIco} from "../../../images/icons/alert-error.svg";

interface OwnProps {
    show: boolean;
    onHide: () => void;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const UnavailablePickupAtModal = ({show, session, onHide, locale}: Props) => {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(false);
    const sessionService = useSessionService();
    const [initialTime] = useState(session.pickup_at ?? "");

    const handleOnClick = async () => {
        try {
            setLoading(true);
            await sessionService.update({
                ...session,
                pickup_at: undefined,
            });
            IframeWidget.onHide(onHide);
        } catch (err) {
            return null;
        } finally {
            setLoading(false);
        }
    };

    return (
        <PopupModal
            title={
                <div className="text-center">
                    <Trans
                        i18nKey="modules.cart.field.unavailable_pickup_at.title"
                        values={{
                            date: DateHelper.getFormattedNearestDate(initialTime, t, locale ?? ""),
                        }}
                        components={{
                            strong: <strong className="text-danger"/>
                        }}
                    />
                </div>
            }
            show={show}
            onHide={onHide}
            withoutCloseButton
            primaryButton={
                <button type="button" className={`btn btn-primary w-100 btn-spinner ${loading ? 'loading' : ''}`}
                        onClick={handleOnClick}>
                    {t("common.action.understand")}
                    <span className="left spinner-border spinner-border-sm me-2"/>
                </button>
            }
            description={t("modules.cart.field.unavailable_pickup_at.description")}
            headerIcon={<AlertIco/>}
            headerIconClassName="text-danger"
        />
    )
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
    locale: selectLocale(state.session),
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(UnavailablePickupAtModal));